var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0649 7.84668C22.0649 9.66112 21.3443 11.4015 20.0614 12.6846C18.7785 13.9677 17.0384 14.6882 15.224 14.6885C13.4096 14.6882 11.6695 13.9677 10.3866 12.6846C9.10369 11.4015 8.38306 9.66112 8.38306 7.84668C8.38332 6.03242 9.10408 4.29264 10.387 3.00977C11.6698 1.72689 13.4097 1.00612 15.224 1.00586C17.0383 1.00612 18.7782 1.72689 20.061 3.00977C21.3439 4.29264 22.0647 6.03242 22.0649 7.84668Z",
    stroke: "#E1E1E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12402 33.0059C1.12402 29.2663 2.60952 25.6804 5.25378 23.0361C7.89805 20.3919 11.4844 18.9062 15.224 18.9062C18.9636 18.9063 22.55 20.3919 25.1942 23.0361C27.8385 25.6804 29.324 29.2663 29.324 33.0059",
    stroke: "#E1E1E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0a7c84be5e002db5ac38be517b30b066.svg";
export { ForwardRef as ReactComponent };